import { render, staticRenderFns } from "./FormSkeleton.vue?vue&type=template&id=74f60978&scoped=true&"
import script from "./FormSkeleton.vue?vue&type=script&lang=js&"
export * from "./FormSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FormSkeleton.vue?vue&type=style&index=0&id=74f60978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f60978",
  null
  
)

export default component.exports